<template>
  <Dialog v-bind:visible="$parent.dialogOpen" :closable="false" modal :draggable="false"
    header="Ein Benutzerkonto Erstellen" class="cua-modal" style="max-width: 30rem;">
    <span class="cua-modal-text">Erstelle ein neues Benutzerkonto für die Fantasyroom Reklamationsverwaltung.</span>
    <div class="cua-modal-inputs">
      <FloatLabel>
        <InputText id="benutzername" type="text" v-model="username" class="cua-modal-btn"></InputText>
        <label for="benutzername">Benutzername</label>
      </FloatLabel>
      <FloatLabel>
        <InputText id="email" type="email" v-model="email" class="cua-modal-btn"></InputText>
        <label for="email">E-Mail Adresse</label>
      </FloatLabel>
      <FloatLabel>
        <InputText id="password" type="password" v-model="password" class="cua-modal-btn"></InputText>
        <label for="password">Passwort</label>
      </FloatLabel>
      <div class="cua-modal-switch">
        <InputSwitch class="cua-modal-switch-s" v-model="passwordResetSwitch" :invalid="!passwordResetSwitch">
        </InputSwitch>
        <span>Den Benutzer direkt auffordern ein eigenes Passwort zu setzen.</span>
      </div>
    </div>
    <div class="cua-modal-btns">
      <Button class="cua-modal-btn" :loading="loading" icon="fa-solid fa-check" @click="createUserAccount"
        severity="success" label="Benutzerkonto Erstellen"></Button>
      <Button class="cua-modal-btn" :disabled="loading" on="fa-solid fa-cancel" @click="close" severity="danger" text
        outlined label="Abbrechen"></Button>

    </div>
  </Dialog>
</template>
<script>
import router from '../router/index.js'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import FloatLabel from "primevue/floatlabel"
import InputSwitch from 'primevue/inputswitch'
import { RouterLink, useRouter } from 'vue-router'
import { getAuth, sendPasswordResetEmail } from 'firebase/auth'
import axios from 'axios'
import { config } from '../assets/config.js'

export default {
  components: {
    Dialog,
    Button,
    FloatLabel,
    InputText,
    InputSwitch
  },

  data() {
    return {
      username: null,
      email: null,
      password: null,
      passwordResetSwitch: true,
      loading: false,
    }
  },

  methods: {
    async createUserAccount() {

      this.loading = true

      if (this.username == null) {
        this.$toast.add({
          severity: 'error',
          summary: 'Erstellung fehlgeschlagen',
          group: "tc",
          detail:
            'Du musst ein Benutzernamen angeben.',
          life: 5000
        })

        this.loading = false;

        return;
      }

      if (this.email == null) {
        this.$toast.add({
          severity: 'error',
          summary: 'Erstellung fehlgeschlagen',
          group: "tc",
          detail:
            'Du musst eine Email-Adresse angeben.',
          life: 5000
        })

        this.loading = false;

        return;
      }


      if (this.password == null) {
        this.$toast.add({
          severity: 'error',
          summary: 'Erstellung fehlgeschlagen',
          group: "tc",
          detail:
            'Du musst ein Passwort angeben.',
          life: 5000
        })

        this.loading = false;

        return;
      }
      let response = await axios.post(config.api_url + '/api/management/users/create', {
        username: this.username,
        email: this.email,
        password: this.password,
      },
        {
          headers: {
            Authorization: await getAuth().currentUser.getIdToken()
          },

        })


      if (response.status == 201) {
        await sendPasswordResetEmail(getAuth(), this.email)
        this.$toast.add({
          severity: 'success',
          summary: 'Benutzerkonto erstellt',
          group: "tc",
          detail:
            response.data,
          life: 5000
        })
        this.username = null;
        this.email = null;
        this.password = null;
        this.passwordResetSwitch = true;
        this.$parent.fetchData()
        this.close()
      } else {
        this.$toast.add({
          severity: 'error',
          summary: 'Fehlermeldung',
          group: "tc",
          detail:
            response.data,
          life: 5000
        })
      }
      this.loading = false;
    },
    close() {
      this.$parent.dialogOpen = false;
    }
  },

  async mounted() { }
}
</script>
<style lang="scss" scoped>
.cua-modal {
  &-text {
    color: var(--gray-400);
  }

  &-inputs {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1.9rem;
  }

  &-btns {
    display: flex;
    gap: 0.5rem;

    position: relative;
  }

  &-switch {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    padding-bottom: 1rem;

    &-s {
      width: 3.2rem;
    }

  }
}
</style>
